<template>
  <div class="pt-3">
    <filter-data
      with_client_portfolios
      :loading_block="loading"
      :months_after="1"
      :months_before="1"
      with_text_search
      with-exchange-situation-select
      :exchange-situation-items="exchange_type"
      :exchange-situation-value="exchange_filter.by_status"
      @doneFilter="handleDoneFilter"
    />
    <exchanges-table
      :items="all_exchanges"
      with_select
      :loading="loading"
      :table-search="tableSearch"
      @doneUpdate="handleDoneUpdate"
    />
  
    <dialog-loading v-if="saving"></dialog-loading>
  </div>
</template>

<script>
const OPEN_ID = 1
const PAYED_ID = 10
import Api from '@/api/index';
import FilterData from '@/components/shared/FilterData.vue'

export default {
  name: 'OpenExchanges',
  inject: {
    registerExchangesListReload: {
      default: () => () => {},
    },
  },
  components: {
    ExchangesTable: () => import('./shared/ExchangesTable'),
    FilterData,
  },
  data() {
    return {
      loading: false,
      saving: false,

      all_exchanges: [],
      local_filter: {},
      exchange_filter: {
        by_status: [OPEN_ID],
      },
      exchange_type:[
        {text:"ABERTOS", value: OPEN_ID },
        {text:"CONCLUÍDOS", value: PAYED_ID},
      ],    
    }
  },
  methods: {
    handleDoneFilter(e) {
      const { by_status, ...rest } = e
      if (by_status !== undefined) {
        this.exchange_filter = { by_status: [...by_status] }
      }
      this.local_filter = { ...rest }
      this.getExchanges()
    },
    handleDoneUpdate(){
      this.getExchanges()
    },
    handleDoneReturned(){},
    getExchanges() {
      this.loading = true
      let filters = {
        modality_ids: [this.activeModalityId],
        ...this.local_filter,
        ...this.exchange_filter,
      }
      this.$emit('doneFilter', {...filters} )
      if (this.activeModalityId){
        Api.Exchange.index(filters).then(r=> r.data).then(d=> {
          this.all_exchanges = [...d]
          this.loading = false
        })
      }
    },
  },
  
  computed: {
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
  },
  mounted() {
    this.registerExchangesListReload(this.getExchanges)
  },
  beforeDestroy() {
    this.registerExchangesListReload(null)
  },
  watch: {
    activeModalityId() {
      this.getExchanges()
    },
  },
}
</script>